import React, { Component } from 'react';
import { Route } from 'react-router';
import { appService } from '../../_services';
//import fs from 'react-fs';

export class GenerateURLLink extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Data: [],
        }
    }

    componentDidMount() {
        var url;
        // console.log(parameters);
        appService.getAll('Product/GetURLLinks?URLpath=' + window.location.origin)
            .then(function (data) {
              //  console.log(data);
                
            })
    }

    render() {
        return (
            <div></div>
        )
    }
}
export default GenerateURLLink;


// WEBPACK FOOTER //
// ./src/components/Google_Scholar/GenerateURLLink.js